import axios from "axios";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../../context/App-Context";

const ReportProfilePic = (props) => {
  const auth = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here

    const formData = new FormData();

    formData.append("email", props.email); // 'profilePic' should match the field name your backend expects

    formData.append("username", props.username); // 'profilePic' should match the field name your backend expects

    //formData.append("profilePic", profilePic); // 'profilePic' should match the field name your backend expects

    // You can append other fields if needed
    // formData.append('bio', bio);
    // formData.append('title', title);

    // console.log("report propic vvv");

    // console.log(formData.get("email"));

    // console.log(formData.get("username"));

    try {
      // Replace with your actual backend endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/reportProfilePic`,
        formData
        // {
        //   Authorization: `Bearer ${auth.token}`,
        //   // Do NOT set Content-Type — let Axios add the boundary
        // }
      );

      // console.log("Upload successful:", response);
      alert("Profile saved successfully!");

      // Optional: reset form or update UI with the new profile pic URL from response
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Error saving profile. Please try again.");
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <button>report profile</button>
      </form>
    </div>
  );
};

export default ReportProfilePic;
